var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolygon2CompleteLightGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 43,
    viewBox: "0 0 39 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 1.3094C17.9752 -0.119662 21.0248 -0.119661 23.5 1.3094L34.9856 7.9406C37.4608 9.36966 38.9856 12.0107 38.9856 14.8688V28.1312C38.9856 30.9893 37.4608 33.6303 34.9856 35.0594L23.5 41.6906C21.0248 43.1197 17.9752 43.1197 15.5 41.6906L4.01443 35.0594C1.53922 33.6303 0.0144291 30.9893 0.0144291 28.1312V14.8688C0.0144291 12.0107 1.53922 9.36966 4.01443 7.9406L15.5 1.3094Z",
    fill: "#E3FFBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon2CompleteLightGreen);
export default __webpack_public_path__ + "static/media/Polygon_2_Complete_light_green.a67bd75354dc9310ea7d5e84065ff1d5.svg";
export { ForwardRef as ReactComponent };